import { Card, Space, Typography } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

const { Text } = Typography

interface Props {
  text: string
}

export const AnswerHelp = ({ text }: Props) => {
  return (
    <Card
      styles={{
        body: {
          paddingTop: 10,
          paddingLeft: 15,
          paddingRight: 15,
          paddingBottom: 10,
        },
      }}
      style={{ marginBottom: 20 }}
    >
      <Space className="w-full" size={10}>
        <QuestionCircleOutlined />
        <Text type="secondary" style={{ whiteSpace: 'pre-wrap' }}>
          {text}
        </Text>
      </Space>
    </Card>
  )
}

export type AnswerHelpType = { Help: typeof AnswerHelp }
